export default {
  en: {
    email_verification: "Email Verification",
    email_verification_verifying: "Verifying Email",
    email_verification_success: "Email Verified",
    email_verification_error: "Email Verification Failed",
  },
  de: {
    email_verification: "E-Mail-Verifizierung",
    email_verification_verifying: "E-Mail wird verifiziert",
    email_verification_success: "E-Mail verifiziert",
    email_verification_error: "E-Mail-Verifizierung fehlgeschlagen",
  },
};
